<template>
  <div class="load-simulation-data">
    <load-simulation-import-excel-button
      class="no-internal-print"
      :has-data="!simulationData.isEmpty"
      :import-data="simulationData.importData"
      :loading="loading"
      @update:loading="onLoading"
    />
    <points-table
      class="mb-3"
      :status="status"
      :initial-date="initialDate"
      :initial-time="initialTime"
      :points-list="simulationData.points"
      :interval="simulationData.interval"
      :loading="loading"
    />
    <load-simulation-data-chart class="mb-3" />
    <load-simulation-repetitions-input
      :repetitions="simulationData.repetitions"
      :loading="loading"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import LoadSimulationImportExcelButton
  from '@/domain/components/installation/engineering/loadSimulation/simulationData/ImportExcelButton';
import PointsTable
  from '@/domain/components/installation/engineering/loadSimulation/simulationData/SimulationDataPointsTable';
import LoadSimulationDataChart
  from '@/domain/components/installation/engineering/loadSimulation/simulationData/SimulationDataChart';
import LoadSimulationRepetitionsInput
  from '@/domain/components/installation/engineering/loadSimulation/simulationData/SimulationRepetitionsInput';

export default {
  name: 'SimulationData',
  props: {
    status: {
      type: Object,
      required: true,
    },
    initialDate: {
      type: String,
      required: true,
    },
    initialTime: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
    },
    conditions: {
      type: Object,
      required: true,
    },
  },
  components: {
    PointsTable,
    LoadSimulationImportExcelButton,
    LoadSimulationDataChart,
    LoadSimulationRepetitionsInput,
  },
  computed: {
    ...mapGetters([
      'simulationData',
    ]),
  },
  created() {
    this.complementWithEditTemplate();
  },
  methods: {
    onLoading(value) {
      this.$emit('update:loading', value);
    },
    complementWithEditTemplate() {
      if (this.conditions.points) {
        Object.assign(this.simulationData.points, this.conditions.points);
      }
      if (this.conditions.timeIntervalBetweenPoints) {
        Object.assign(this.simulationData.interval, this.conditions.timeIntervalBetweenPoints);
      }
      if (this.conditions.simulationRepetitionsNumber) {
        this.simulationData.repetitions = this.conditions.simulationRepetitionsNumber;
      }
    },
  },
};
</script>
